import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Request_Get_Registers_Fuzzy_Search } from "../api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_Registers_With_Options } from "../../../api/Get_Registers_With_Options";
import TableRegisters from "./components/TableRegisters";

function LiveTable() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([]);
  useEffect(() => {
    Get_Registers_With_Options(
      "Registers_2025",
      "All",
      { ProgrammeTitle: "Summer" },
      200000,
      {
        customProject: {
          BasicInfo: 1,
          MetaData: 1,
          _id: 1,
        },
      },
      setRegisters,
      logout
    );
  }, []);

  const [Programmes, setProgrammes] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("Lookups", "Programmes_2025", setProgrammes, logout);
  }, []);

  // -----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <TableRegisters
          style={{ flex: "0 1 auto" }}
          Registers={Registers}
          Programmes={Programmes}
        />
      </div>
    </div>
  );
}

export default LiveTable;
